import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import _map from 'lodash/map';
import _noop from 'lodash/noop';
import _size from 'lodash/size';
import _head from 'lodash/head';
import _isEmpty from 'lodash/isEmpty';

// Constants
import { EMPTY_OBJECT, EMPTY_ARRAY } from '@tekion/tekion-base/app.constants';

// Components
import { Dropdown, Menu } from 'antd';
import Button from '../../atoms/Button';
import FontIcon, { SIZES } from '../../atoms/FontIcon';

// Helpers
import { getMenuOptions, getPrimaryOption } from './buttonWithMenu.helpers';

// Styles
import s from './buttonWithMenu.module.scss';
var DropdownButton = Dropdown.Button;
var Item = Menu.Item;
var ButtonWithMenu = /*#__PURE__*/function (_Component) {
  _inherits(ButtonWithMenu, _Component);
  var _super = _createSuper(ButtonWithMenu);
  function ButtonWithMenu() {
    var _this;
    _classCallCheck(this, ButtonWithMenu);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "renderMenuItem", function () {
      var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_OBJECT;
      return /*#__PURE__*/React.createElement(Item, {
        key: option.id
      }, option.name);
    });
    _defineProperty(_assertThisInitialized(_this), "renderMenu", function () {
      var _this$props = _this.props,
        options = _this$props.options,
        primaryOptionId = _this$props.primaryOptionId;
      var menuOptions = getMenuOptions(options, primaryOptionId) || EMPTY_ARRAY;
      return /*#__PURE__*/React.createElement(Menu, {
        onClick: _this.handleMenuClick
      }, _map(menuOptions, _this.renderMenuItem));
    });
    _defineProperty(_assertThisInitialized(_this), "handleMenuClick", function (action) {
      var onClick = _this.props.onClick;
      onClick(action.key);
    });
    _defineProperty(_assertThisInitialized(_this), "handlePrimaryButtonClick", function () {
      var _this$props2 = _this.props,
        options = _this$props2.options,
        primaryOptionId = _this$props2.primaryOptionId,
        onClick = _this$props2.onClick;
      var primaryOption = getPrimaryOption(options, primaryOptionId) || EMPTY_OBJECT;
      onClick(primaryOption.id);
    });
    _defineProperty(_assertThisInitialized(_this), "renderButton", function () {
      var _this$props3 = _this.props,
        options = _this$props3.options,
        view = _this$props3.view,
        buttonProps = _this$props3.buttonProps,
        loading = _this$props3.loading,
        className = _this$props3.className;
      var option = _head(options) || EMPTY_OBJECT;
      return /*#__PURE__*/React.createElement(Button, _extends({}, buttonProps, {
        label: option.name,
        view: view,
        onClick: _this.handlePrimaryButtonClick,
        loading: loading,
        className: className
      }));
    });
    _defineProperty(_assertThisInitialized(_this), "renderIcon", function () {
      var _this$props4 = _this.props,
        icon = _this$props4.icon,
        fontIconProps = _this$props4.fontIconProps;
      return /*#__PURE__*/React.createElement(FontIcon, _extends({}, fontIconProps, {
        size: SIZES.S,
        className: cx(s.iconClassName, fontIconProps.className)
      }), icon);
    });
    return _this;
  }
  _createClass(ButtonWithMenu, [{
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
        options = _this$props5.options,
        primaryOptionId = _this$props5.primaryOptionId,
        view = _this$props5.view,
        buttonProps = _this$props5.buttonProps,
        loading = _this$props5.loading,
        className = _this$props5.className;
      if (_isEmpty(options)) return null;
      if (_size(options) === 1 || loading) return this.renderButton();
      var primaryOption = getPrimaryOption(options, primaryOptionId) || EMPTY_OBJECT;
      return /*#__PURE__*/React.createElement(DropdownButton, _extends({}, buttonProps, {
        className: cx(s.dropdownButton, buttonProps.className, className),
        type: view,
        onClick: this.handlePrimaryButtonClick,
        overlay: this.renderMenu,
        icon: this.renderIcon()
      }), primaryOption.name);
    }
  }]);
  return ButtonWithMenu;
}(Component);
ButtonWithMenu.VIEW = Button.VIEW;
ButtonWithMenu.propTypes = {
  onClick: PropTypes.func,
  options: PropTypes.array,
  primaryOptionId: PropTypes.string,
  view: PropTypes.string,
  icon: PropTypes.string,
  fontIconProps: PropTypes.object,
  buttonProps: PropTypes.object,
  loading: PropTypes.bool,
  className: PropTypes.string
};
ButtonWithMenu.defaultProps = {
  onClick: _noop,
  options: EMPTY_ARRAY,
  primaryOptionId: '',
  view: ButtonWithMenu.VIEW.primary,
  icon: 'icon-chevron-down',
  fontIconProps: EMPTY_OBJECT,
  buttonProps: EMPTY_OBJECT,
  loading: false,
  className: undefined
};
export default ButtonWithMenu;